import { P6Icon, ToggleItem, ToggleText, TopBottomToggleWrapper } from "./StyledComponents";

interface SmallTextToggleProps {
    isLeft: boolean;
    togglePosition: () => void;
    leftText: string;
    rightText: string;
    disabled?: boolean;
    leftIconName?: string;
    rightIconName?: string;
}

const SmallTextToggle = (props: SmallTextToggleProps) => {
    const renderToggleHalf = (label: string, isActive: boolean, iconName?: string) => {
        return (
            <ToggleItem isActive={isActive}>
                {iconName && <P6Icon name={iconName} />}
                <ToggleText>{label}</ToggleText>
            </ToggleItem>
        );
    };

    return (
        <TopBottomToggleWrapper
            disabled={props.disabled}
            onClick={() => !props.disabled && props.togglePosition()}
        >
            {renderToggleHalf(props.leftText, props.isLeft, props.leftIconName)}
            {renderToggleHalf(props.rightText, !props.isLeft, props.rightIconName)}
        </TopBottomToggleWrapper>
    );
};

export default SmallTextToggle;
